<div class="animated animate__fadeIn">
  <ng-container *ngIf="header">
    <div class="p-2 d-flex justify-content-between align-items-center flex-wrap gap-10">
      <h4 class="m-0 c-pointer" [routerLink]="['/device/waterwise', data.id]">{{data.name}}</h4>
      <div class="d-flex gap-10 buttons-header">
        <button id="config" class="btn btn-outline-primary" (click)="viewModalTestDevice = true">
          <em class="fa fa-wifi"></em>
        </button>

        <button class="btn btn-outline-primary" (click)="viewConfig()">
          <em class="fa fa-cog"></em>
        </button>
        <button
          class="btn btn-outline-primary"
          [routerLink]="['/device/waterwise', data.id]"
          [queryParams]="{ view: 'sensors_graph' }"
        >
          <app-image-color
            [height]="'15px'"
            [width]="'20px'"
            [url]="'menu-icons/parametrias.svg'"
            [color]="'#204349'"
          ></app-image-color>
        </button>
        <button
          class="btn btn-sm"
          style="width: fit-content"
          placement="top"
          container="body"
          [ngbTooltip]="data.power ? ('sensors-value.turn-off-device' | translate) : ('sensors-value.turn-on-device' | translate)"
          [class]="data.power ? 'btn-outline-success' : 'btn-danger'"
          (click)="turOnOffWaterwise()"
        >
          <i class="fa fa-power-off" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="container-sensors mt-2" *ngIf="view_sensors || view_sensors_hydro">
    <div
      class="sensor"
      *ngFor="let item of sensors"
      [ngClass]="{'d-none': !checks_parametry_preference[item.preference]}"
    >
      <ng-container *ngIf="item.is_hydro && view_sensors">
        <div
          class="sensor-card"
          triggers="hover focus"
          ngbTooltip="{{item.label | translate}}"
          [style.background-color]="item.validateLowColorSensor(data,item)"
          [style.border]="'0px solid ' + item.validateHighColorSensor(data,item)"
        >
          <div class="d-flex flex-column justify-content-center align-items-center">
            <app-image-color
              [width]="'30px'"
              [height]="'30px'"
              [url]="item.image"
              [color]="item.validateHighColorSensor(data,item)"
            ></app-image-color>
            <h5 class="text-white m-0">{{item.label_table | translate}}</h5>
          </div>
          <div>
            <h4 class="title" style="width: 100%; text-align: center">
              <p class="text-white">
                {{item.value(data,item)}}<small class="font-weight-bold"
                  >{{item.measurementThreshold}}</small
                >
              </p>
            </h4>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!item.is_hydro && view_sensors_hydro ">
        <div
          [ngbPopover]="info"
          class="sensor-card"
          [style.background-color]="item.validateLowColorSensor(data,item)"
          [style.border]="'0px solid ' + item.validateHighColorSensor(data,item)"
        >
          <div class="d-flex flex-column justify-content-center align-items-center">
            <app-image-color
              [width]="'30px'"
              [height]="'30px'"
              [url]="item.image"
              [color]="item.validateHighColorSensor(data,item)"
            ></app-image-color>
            <h5 class="text-white m-0">{{item.label_table | translate}}</h5>
          </div>
          <div>
            <h4 class="title">
              <p class="text-white">
                {{item.value(data,item)}}<small class="font-weight-bold"
                  >{{item.measurementThreshold}}</small
                >
              </p>
            </h4>
          </div>
        </div>

        <ng-template #info>
          <div class="p-2 content">
            <h4 class="title">{{item.label | translate}}</h4>
            <div class="sensors-content">
              <div class="sensor-item">
                <h4 class="m-0">{{item.min_value(data,item)}} {{item.measurementThreshold}}</h4>
                <small>{{ "sensors-value.min" | translate }}</small>
              </div>
              <div class="sensor-item">
                <h3
                  class="middle-text m-0"
                  [style.color]="validateColorAlert(item.prop, data.sensors[item.prop])"
                >
                  {{item.value(data,item)}} {{item.measurementThreshold}}
                </h3>
                <small>{{ "sensors-value.current" | translate }}</small>
              </div>
              <div class="sensor-item">
                <h4 class="m-0">{{item.max_value(data,item)}} {{item.measurementThreshold}}</h4>
                <small>{{ "sensors-value.max" | translate }}</small>
              </div>
            </div>

            <div class="d-flex justify-content-around mt-3">
              <div class="sensor-item">
                <h4
                  class="m-0"
                  [style.color]="validateColorAlert(item.prop, data.sensors[item.prop + '_min'])"
                >
                  {{item.min_value(data,item)}} {{item.measurementThreshold}}
                </h4>
                <small>{{ "sensors-value.min-today" | translate }}</small>
                <small class="m-0"> {{insertTimezone(item.prop +'_min_time')}} </small>
              </div>

              <div class="sensor-item">
                <h4
                  class="m-0"
                  [style.color]="validateColorAlert(item.prop, data.sensors[item.prop + '_max'])"
                >
                  {{data.sensors.temp_max ? data.sensors.temp_max : '?'}}°C
                </h4>
                <small>{{ "sensors-value.max-today" | translate }}</small>
                <small class="m-0"> {{insertTimezone( item.prop + '_max_time')}} </small>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="footer">
    <div class="footer-sensor mt-4">
      <div
        class="view-alert"
        [ngStyle]="{'background-color': data.fuzzy_logic ? colors.low_success : colors.low_danger}"
        placement="top"
        container="body"
        [ngbTooltip]="'sensors-value.smart-feeding' | translate"
        *ngIf="permissions.view_feedingfuzzylogic"
      >
        <p class="m-0 ml-2 font-weight-bold text-white">AI</p>
        <label class="switch m-0">
          <input
            type="checkbox"
            id="fuzzy_logic"
            [(ngModel)]="data.fuzzy_logic"
            [value]="data.fuzzy_logic"
            name="fuzzy_logic"
            (change)="changelfblock()"
          />
          <span class="slider round"></span>
        </label>
      </div>
      <!-- Comunicacion -->
      <div
        class="view-alert"
        [ngStyle]="{'background-color': data.alert_comm ? colors.low_danger : colors.low_success}"
        placement="top"
        container="body"
        [ngbTooltip]="('alerts.general.comm-status-tooltip' | translate) + ': ' + (data.alert_comm ? ('alerts.general.comm-status-inactive' | translate) : ('alerts.general.comm-status-active' | translate))"
      >
        <div class="d-flex align-items-center w-icon">
          <app-image-color
            [height]="'10px'"
            [width]="'20px'"
            [url]="'img/icons/senal-blanco.svg'"
            [color]="data.alert_comm ? colors.high_danger : colors.high_success"
          ></app-image-color>
          <p class="m-0 ml-2 font-weight-bold text-white">
            {{'alerts.general.communication' | translate}}
          </p>
        </div>
      </div>
      <div
        class="view-alert"
        style="justify-content: flex-start"
        [ngStyle]="{'background-color': validateColorImage(data, 'battery')}"
        placement="top"
        container="body"
        [ngbTooltip]="('alerts.general.battery' | translate) + ': '+ data.battery"
      >
        <app-icon-battery
          class="w-icon center"
          [value]="data.battery"
          [height]="'13px'"
          [width]="'25px'"
          [font_size]="'13px'"
          [color]="validateColorImage(data, 'battery',this.colors.high_success,this.colors.high_warning,this.colors.high_danger)"
          [dark]="true"
        ></app-icon-battery>
        <p class="m-0 ml-2 font-weight-bold text-white">{{ "alerts.general.battery" | translate }}</p>
      </div>
      <div
        class="view-alert"
        style="justify-content: flex-start"
        [ngStyle]="{'background-color': validateColorImage(data, 'panel')}"
        placement="top"
        container="body"
        [ngbTooltip]="('alerts.general.panel' | translate) + ': '+ data.panel"
      >
        <app-image-color
          [height]="'15px'"
          [width]="'30px'"
          [url]="'img/icons/panel.svg'"
          [color]="validateColorImage(data, 'panel',this.colors.high_success,this.colors.high_warning,this.colors.high_danger)"
        ></app-image-color>
        <p class="m-0 ml-2 font-weight-bold text-white">{{ "alerts.general.panel" | translate }}</p>
      </div>
      <div
        class="view-alert"
        ngbDropdown
        [ngStyle]="{'background-color': validateColorMaintenance(data.maintenance_score,'low')}"
        placement="top"
        container="body"
      >
        <div ngbDropdownToggle id="dropdownForm1" class="d-flex align-items-center">
          <i
            class="fa fa-wrench"
            aria-hidden="true"
            style="font-size: 20px"
            [ngStyle]="{'color': validateColorMaintenance(data.maintenance_score,'high')}"
          ></i>
          <p class="m-0 ml-2 font-weight-bold text-white">{{ "alerts.actions.maintenance" | translate }}</p>
        </div>

        <div ngbDropdownMenu aria-labelledby="dropdownForm1" style="margin: 0px; padding: 0px">
          <div
            class="bg-primary p-3 text-white d-flex justify-content-between align-items-center flex-column gap-10"
          >
            <div class="text-white d-flex justify-content-between align-items-center">
              <div>{{ "admin.region.maintenance-alert" | translate }}</div>
            </div>
            <!-- Opción Reiniciar -->
            <button
              class="btn btn-secondary d-flex align-items-center"
              (click)="resetAlertWaterwise('alert_maintenance',false)"
            >
              <i class="fa fa-sync-alt mr-2"></i>
              <span>{{ "sensors-value.restart-alert" | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #modalconfigSensed>
  <div
    class="modal-header d-flex bg-primary p-2 align-items-center justify-content-between border-header"
  >
    <div class="d-flex align-items-center flex-wrap p-2 border-header">
      <div class="d-none d-lg-flex align-items-center">
        <em class="fa fa-cog fa-2x text-white mr-3"></em>
      </div>
      <div class="line bg-white d-none d-lg-flex"></div>
      <div class="text-left ml-2">
        <div class="flex-column">
          <h2 class="mb-0 d-flex align-items-start">{{ "sensors-value.sensor-config" | translate }}</h2>
          <p class="m-0">{{ "sensors-value.sensor-config-subtitle" | translate }}</p>
        </div>
      </div>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(modalconfigSensed, 'hide')">&times;</h3>
  </div>

  <div class="modal-body">
    <div *ngIf="data && data.id">
      <app-config-sensors-device
        [type]="'waterwise'"
        [id]="data.id"
        [pond_id]="data.pond.id"
      ></app-config-sensors-device>
    </div>
  </div>
</ng-template>

<app-frames-device-dynamic
  *ngIf="viewModalTestDevice"
  [devices]="[data]"
  (closed)="closePanel()"
  [type]="'waterwise'"
></app-frames-device-dynamic>
